import * as Rox from "rox-browser";

export const chat = {
    chatBot: new Rox.Flag(),
    chatBotAivo: new Rox.Flag(),
    chatBotAivoRealocated: new Rox.Flag(),
};
